var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"router-view",style:({ paddingBottom: _vm.nativeCallpadding })},[_c('router-view'),_c('AlertWithIcon'),_c('AlertWithoutIcon'),_c('LoadingSpinner')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }